import { app } from '../../../../../bootstrap/core';
import { paymentPartnerEditingComponent } from './paymentPartnerEditing.component';

app.component('paymentPartnerEditing', paymentPartnerEditingComponent);
